<template>
	<div class="ai-banner">
		<a href="https://www.netcall.com/platform/ai/" class="ai-more" target="_blank">More</a>
		<h3 class="ai-heading">
			Harness the power of AI
		</h3>
		<div class="ai-grid">
			<!--p class="ai-subheading">
				Unleash the transformative power of AI to craft bespoke business software that future-proofs your operation, driving innovation and unparalleled efficiency.
			</p-->
			<div class="ai-icons">
				<a class="ai-icon text-extraction" @click="openPromoModal('text_extraction')">
					<span class="icon"><i></i></span>
					<span class="text">Text Extraction</span>
				</a>
				<a class="ai-icon data-prediction" @click="openPromoModal('data_prediction')">
					<span class="icon"><i></i></span>
					<span class="text">Data Prediction</span>
				</a>
				<a class="ai-icon time-series-analysis" @click="openPromoModal('time_series_analysis')">
					<span class="icon"><i></i></span>
					<span class="text">Time Series Analysis</span>
				</a>
				<a class="ai-icon sentiment-analysis" @click="openPromoModal('sentiment_analysis')">
					<span class="icon"><i></i></span>
					<span class="text">Sentiment Analysis</span>
				</a>
				<a class="ai-icon text-summarisation" @click="openPromoModal('text_summarisation')">
					<span class="icon"><i></i></span>
					<span class="text">Text Summarisation</span>
				</a>
				<a class="ai-icon keyword-extraction" @click="openPromoModal('keyword_extraction')">
					<span class="icon"><i></i></span>
					<span class="text">Keyword Extraction</span>
				</a>
				<a class="ai-icon text-enhancement" @click="openPromoModal('enhance_text_rewrite')">
					<span class="icon"><i></i></span>
					<span class="text">Text Enhancement</span>
				</a>
			</div>
		</div>
		<modal v-if="show_promo_modal" @close="closePromoModal">
			<template #header>
				<p class="AI-icon" :class="promo_modal_sections[promo_modal_section_name]?.icon || ''">
					<span class="icon"><i></i></span>
				</p>
				<p class="modal-title" v-text="promo_modal_sections[promo_modal_section_name]?.title || ''"></p>
			</template>
			<template #content>
				<template v-if="in_test_mode">
					<div class="leftColumn">
						<div class="form-field">
							<label class="form-label title">
								<help label="ai.models.testing_input">Input Text</help>
							</label>
							<textarea v-model="testing_data.text" class="width-100 min-height-200 max-height-400 mt-20" maxlength="800"></textarea>
						</div>
						<div v-if="promo_modal_section_name === 'enhance_text_rewrite'" class="form-field mt-20">
							<label class="form-label title">
								<help label="ai.models.mode_input">Mode</help>
							</label>
							<select v-model="testing_data.mode" class="width-100 mt-20">
								<option value="correct">
									Correct
								</option>
								<option value="expand">
									Expand
								</option>
								<option value="tone_formal">
									Formal tone
								</option>
								<option value="tone_friendly">
									Friendly tone
								</option>
							</select>
						</div>
						<div class="text mt-10">
							<button
								class="btn btn-save"
								title="Go"
								:class="{ disabled: testing_in_progress }"
								:disabled="testing_in_progress"
								@click="runTest"
								v-text="'Go'"
							></button>
						</div>
					</div>
					<div class="leftColumn">
						<p class="title mb-15">
							<fa :icon="['far', 'sparkles']" class="ai-icon" /> <span class="ai-says">Liberty AI</span> says...
						</p>
						<template v-if="promo_modal_section_name === 'sentiment_analysis'">
							<p v-if="testing_results?.score !== undefined" class="overview text">
								<span v-if="testing_results?.label !== undefined" class="badge" :class="{'badge-success': testing_results.label.toLowerCase() === 'positive', 'badge-danger': testing_results.label.toLowerCase() === 'negative'}" v-text="testing_results.label"></span> with a score of <b v-text="testing_results.score"></b>
							</p>
							<p v-if="testing_in_progress" class="overview text">
								<span class="waiting">Thinking...</span>
							</p>
						</template>
						<template v-if="promo_modal_section_name === 'text_summarisation'">
							<p v-if="testing_results?.summary !== undefined" class="overview text">
								<span class="text" v-text="summaryTest()"></span>
							</p>
							<p v-if="testing_in_progress" class="overview text">
								<span class="waiting">Thinking...</span>
							</p>
						</template>
						<template v-if="promo_modal_section_name === 'keyword_extraction'">
							<p v-if="testing_results?.keywords !== undefined" class="overview text">
								<span v-for="(keyword, index) in keywordsTest()" :key="index" class="badge badge-blue mr-5 mb-5">
									{{ keyword }}
								</span>
								<span v-if="testing_results.keywords.length > 15">+ {{ testing_results.keywords.length - 15 }}</span>
							</p>
							<p v-if="testing_in_progress" class="overview text">
								<span class="waiting">Thinking...</span>
							</p>
						</template>
						<template v-if="promo_modal_section_name === 'enhance_text_rewrite'">
							<p v-if="testing_results?.text !== undefined" class="overview text">
								<span class="text" v-text="outputTextTest()"></span>
							</p>
							<p v-if="testing_in_progress" class="overview text">
								<span class="waiting">Thinking...</span>
							</p>
						</template>
					</div>
				</template>
				<template v-else>
					<div class="leftColumn mb-20">
						<p class="title">
							Overview
						</p>
						<p class="overview text">
							{{ promo_modal_sections[promo_modal_section_name]?.overview }}
						</p>
					</div>
					<div class="leftColumn">
						<p class="title">
							Pricing
						</p>
						<p class="text">
							{{ promo_modal_sections[promo_modal_section_name]?.pricing }}
							<a href="https://docs.netcall.com/docs/liberty-ai/latest/ai-units" class="link" target="_blank">Learn more</a>
						</p>
						<p class="title">
							Documentation
						</p>
						<p class="text">
							{{ promo_modal_sections[promo_modal_section_name]?.tutorials_and_documentation }}
							<a href="https://docs.netcall.com/docs/liberty-ai/latest/nlp-services" class="link" target="_blank">Learn more</a>
						</p>
						<div v-if="promo_modal_sections[promo_modal_section_name]?.tray_now_button" class="text">
							<button class="btn btn-save" title="Try it now" @click="toTestMode">
								<fa :icon="['far', 'sparkles']" /> Try it now
							</button>
						</div>
					</div>
				</template>
			</template>
		</modal>
	</div>
</template>

<script lang="ts">
	import { Options, Vue } from 'vue-class-component';
	import { HttpHelper } from '../../helper/http';
	import Modal from './../Modal.vue';

	@Options({
		name: 'AI Promo Banner',
		components: { Modal },
		inject: ['http'],
	})
	export default class AiPromoBanner extends Vue {
		public http!: HttpHelper;
		public show_promo_modal: boolean = false;
		public in_test_mode: boolean = false;
		public promo_modal_section_name: string = 'sentiment_analysis';
		public testing_data: { text: string; mode: string } = { text: '', mode: 'expand' };
		public testing_results: any = {};
		public testing_results_request_count = 0;
		public interval_test: any;
		public testing_in_progress: boolean = false;
		public promo_modal_sections: any = {};

		public get servicePath(): string {
			switch (this.promo_modal_section_name) {
			case 'sentiment_analysis':
				return 'analyze-sentiment/submit';
			case 'text_summarisation':
				return 'summarize-text/submit';
			case 'keyword_extraction':
				return 'extract-keywords/submit';
			case 'enhance_text_rewrite':
				return 'enhance-text/submit';
			default:
				return '';
			}
		}

		public get currentVersion(): string {
			return this.$store.state.configuration.currentVersion;
		}

		public summaryTest(): string {
			return (this.testing_results?.summary?.length > 500) ? this.testing_results?.summary?.slice(0, 499) + ' …' : this.testing_results?.summary;
		}

		public keywordsTest(): Array<string> {
			return (this.testing_results?.keywords?.length > 15) ? this.testing_results?.keywords?.slice(0, 14) : this.testing_results?.keywords;
		}

		public outputTextTest(): string {
			return (this.testing_results?.text?.length > 500) ? this.testing_results?.text?.slice(0, 499) + ' …' : this.testing_results?.text;
		}

		public openPromoModal(section: string): void {
			this.promo_modal_section_name = section;
			this.in_test_mode = false;
			this.show_promo_modal = true;
		}

		public closePromoModal(): void {
			this.show_promo_modal = false;
			this.in_test_mode = false;
			this.promo_modal_section_name = '';
			this.testing_data = { text: '', mode: 'expand' };
			this.testing_results = {};
			this.testing_in_progress = false;
		}

		public toTestMode(): void {
			this.in_test_mode = true;
		}

		public async runTest(): Promise<void> {
			if (this.testing_data.text === '') {
				this.$store.dispatch('notification/add', {
					type: 'warning',
					message: 'Please enter text to test',
				});
				return;
			}

			this.testing_in_progress = true;
			this.testing_results = {};

			const test_tata = this.prepareTestData();

			const response = await this.http.post(`/api/ai/testing/${this.servicePath}`, test_tata);
			const result = await response.json();
			if (response.status === 200) {
				if (result.status === 'requested') {
					this.interval_test = setInterval(() => {
						this.getTestResults(result.test);
					}, 2000);
				} else {
					this.$store.dispatch('notification/add', {
						type: 'error',
						message: 'Unable to run AI test',
					});

					this.testing_in_progress = false;
				}
			} else {
				this.$store.dispatch('notification/add', {
					type: 'error',
					message: 'Unable to run AI test',
				});

				this.testing_in_progress = false;
			}
		}

		public async getTestResults(test: string): Promise<void> {
			const response = await this.http.get(`/api/ai/testing/${test}/results`);
			const result = await response.json();
			if (response.status === 200) {
				if (result.status === 'completed') {
					this.testing_results = result.response.result;
					clearInterval(this.interval_test);

					this.testing_in_progress = false;

					return;
				}
				if (result.status === 'failed') {
					clearInterval(this.interval_test);

					this.$store.dispatch('notification/add', {
						type: 'error',
						message: 'Unable to fetch AI results',
					});

					this.testing_in_progress = false;

					return;
				}
			}

			if (this.testing_results_request_count > 30) {
				clearInterval(this.interval_test);

				this.$store.dispatch('notification/add', {
					type: 'error',
					message: 'Unable to fetch AI results',
				});

				this.testing_in_progress = false;
				return;
			}

			this.testing_results_request_count++;
		}

		public prepareTestData(): Record<string, any> {
			const test_data = {
				text: this.testing_data.text,
			} as any;

			if (this.promo_modal_section_name === 'enhance_text_rewrite') {
				test_data.task = this.testing_data.mode;
			}

			return test_data;
		}

		public async requestAiProductsInfo(): Promise<void> {
			const response = await this.http.get('/api/ai/models/promo-info');
			if (response.status === 200) {
				this.promo_modal_sections = await response.json();
			}
		}

		public mounted(): void {
			this.requestAiProductsInfo();
		}
	}
</script>

<style lang="scss" scoped>
	@import '../../assets/styles/base';

	.ai-banner {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		background-image: url("./../images/ai-banner.jpg");
		background-position: bottom center;
		background-size: cover;
		background-color: $controller-color;
		padding: 2em;
		border-radius: 0.5rem;
		min-height: 225px;
		margin-bottom: 1rem;
		@media (max-width: 770px) {
			background-position-x: 740px;
			background-position-y: bottom;
		}
		.ai-more {
			position: absolute;
			right: 2em;
			top: 26px;
			display: inline-block;
			padding: 5px 12px;
			border: 2px rgba(white, 0.4) solid;
			border-radius: 30px;
			color: white;
			transition: all ease-in-out 0.5s;
			&:hover {
				color: $controller-color;
				background-color: white;
				transition: all ease-in-out 0.3s;
			}
		}
		.ai-heading {
			font-family: $primary-font-family;
			font-size: 26px;
			font-weight: 600;
			letter-spacing: -0.4px;
			margin: 0 0 1rem 0;
			color: white;
			padding-right: 3em;
		}
		.ai-subheading {
			font-family: $primary-font-family;
			font-size: 20px;
			font-weight: 400;
			color: white;
			line-height: 26px;
			flex-basis: max(25ch, 35%);
		}
		.ai-grid {
			gap: 1rem;
			display: flex;
			flex-wrap: wrap;
		}
		.ai-icons {
			display: flex;
			gap: 1rem;
			@media (max-width: 770px) {
				display: grid;
				gap: 1rem;
				grid-template-columns: 1fr 1fr 1fr 1fr;
			}
			.ai-icon {
				display: flex;
				flex-direction: column;
				align-content: center;
				align-items: center;
				text-wrap: wrap;
				cursor: pointer;
				max-width: 80px;
				.icon {
					display: flex;
					flex-direction: column;
					align-content: center;
					align-items: center;
					text-wrap: wrap;
					justify-content: center;
					background: rgba(0, 0, 0, 0.4);
					width: 4rem;
					height: 4rem;
					aspect-ratio: 1;
					padding: 0.5rem;
					border-radius: 10px;
					margin-bottom: 1em;
					transition: all ease-in-out 0.5s;
					&:hover {
						box-shadow: 0 3px 3px rgba(138, 248, 255, 0.678), 0 0px 16px rgba(231, 126, 231, 0.741), 0 -2px 4px rgba(255, 87, 34, 0.8), 0 -4px 8px rgba(255, 255, 255, 0.4), 0 8px 16px rgba(0, 188, 212, 0.4), inset 0px 2px 2px white;
						transition: all ease-in-out 0.5s;
					}
					i {
						width: 100%;
						aspect-ratio: 1;
						background-repeat: no-repeat;
						background-position: center center;
						background-size: min(100%, 2em);
					}
				}
				.text {
					display: block;
					font-family: $primary-font-family;
					font-size: 11px;
					font-weight: 700;
					color: white;
					text-shadow: 0 2px 0 black;
					max-width: 100%;
					text-align: center;
					line-height: 1.2;
					hyphens: auto;
				}
				&:hover {
					.icon {
						background: rgba(0, 0, 0, 0.6);
						transition: all ease-in-out 0.2s;
						padding: 0.95em;
					}
				}
				&.text-extraction .icon i {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 60'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cpolygon class='b' points='37 0 37 15 52 15 37 0'/%3E%3Cpath class='b' d='M33.25,15V0H14.5c-4.14,0-7.5,3.36-7.5,7.5v26h14.5c3.03,0,5.5,2.47,5.5,5.5s-2.47,5.5-5.5,5.5H7v8c0,4.14,3.36,7.5,7.5,7.5h30c4.14,0,7.5-3.36,7.5-7.5V18.75h-15c-2.07,0-3.75-1.68-3.75-3.75ZM34.5,51.5H15.5c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h19c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5ZM48,29c0,1.38-1.12,2.5-2.5,2.5h-19c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h19c1.38,0,2.5,1.12,2.5,2.5Z'/%3E%3Cpath class='b' d='M21.5,41.5c1.38,0,2.5-1.12,2.5-2.5s-1.05-2.42-2.37-2.49c-.04,0-.08-.01-.13-.01H2.5c-.07,0-.13.01-.19.02-1.17.09-2.11.99-2.27,2.14-.02.11-.03.22-.03.34,0,.11.02.21.03.31.15,1.23,1.2,2.19,2.47,2.19h19Z'/%3E%3C/svg%3E");
				}
				&.data-prediction .icon i {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 75 60'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M0,56.87c0-8.62,7-15.62,15.62-15.62h6.25c8.64,0,15.63,7,15.63,15.62,0,1.72-1.39,3.13-3.13,3.13H3.13c-1.73,0-3.13-1.39-3.13-3.13ZM7.5,26.25c0-4.02,2.14-7.73,5.62-9.74,3.48-2.01,7.77-2.01,11.25,0,3.48,2.01,5.62,5.72,5.62,9.74s-2.14,7.73-5.62,9.74c-3.48,2.01-7.77,2.01-11.25,0-3.48-2.01-5.62-5.72-5.62-9.74ZM18.75,7.5c0-4.14,3.36-7.5,7.5-7.5h41.25c4.14,0,7.5,3.36,7.5,7.5v33.75c0,4.14-3.36,7.5-7.5,7.5h-28.03c-1.38-2.99-3.5-5.57-6.14-7.5h34.17V7.5H26.25v5.75c-2.2-1.28-4.77-2-7.5-2v-3.75ZM48.36,16.32c-.54-.54-.69-1.35-.41-2.04s.97-1.16,1.73-1.16h10.31c1.03,0,1.88.84,1.88,1.88v10.31c0,.76-.46,1.44-1.16,1.73s-1.51.13-2.04-.41l-3.16-3.16-8.52,8.52c-1.1,1.1-2.88,1.1-3.97,0l-7.5-7.5c-1.1-1.1-1.1-2.88,0-3.97s2.88-1.1,3.97,0l5.51,5.51,6.53-6.53-3.16-3.16h0Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
				}
				&.time-series-analysis .icon i {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 75 56.25'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M18.75,24.38h18.75v-6.41c-3.32-1.44-5.62-4.75-5.62-8.59,0-5.18,4.2-9.38,9.38-9.38s9.38,4.2,9.38,9.38c0,3.84-2.31,7.15-5.62,8.59v6.41h17.19l-4.85-4.84c-1.46-1.46-1.46-3.84,0-5.31s3.84-1.46,5.31,0l11.25,11.25c1.46,1.46,1.46,3.84,0,5.31l-11.25,11.25c-1.46,1.46-3.84,1.46-5.31,0s-1.46-3.84,0-5.31l4.85-4.85H30v6.41c3.32,1.44,5.62,4.75,5.62,8.59,0,5.18-4.2,9.38-9.38,9.38s-9.38-4.2-9.38-9.38c0-3.84,2.31-7.15,5.62-8.59v-6.41H3.75c-2.07,0-3.75-1.68-3.75-3.75s1.68-3.75,3.75-3.75h7.5v-6.41c-3.32-1.44-5.62-4.75-5.62-8.59C5.62,4.2,9.82,0,15,0s9.38,4.2,9.38,9.38c0,3.84-2.31,7.15-5.62,8.59v6.41ZM12.19,9.38c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81-1.26-2.81-2.81-2.81-2.81,1.26-2.81,2.81ZM23.44,46.88c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81-1.26-2.81-2.81-2.81-2.81,1.26-2.81,2.81ZM41.25,12.19c1.55,0,2.81-1.26,2.81-2.81s-1.26-2.81-2.81-2.81-2.81,1.26-2.81,2.81,1.26,2.81,2.81,2.81Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
				}
				&.sentiment-analysis .icon i {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 60'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M28.12,15h-4.07c-.77-2.18-2.86-3.75-5.31-3.75-3.11,0-5.62,2.52-5.62,5.62s2.52,5.62,5.62,5.62c2.45,0,4.54-1.57,5.31-3.75h4.07v9.38h-5.62c-3.11,0-5.62,2.52-5.62,5.62v4.07c-2.18.77-3.75,2.86-3.75,5.31,0,3.11,2.52,5.62,5.62,5.62s5.62-2.52,5.62-5.62c0-2.45-1.57-4.54-3.75-5.31v-4.07c0-1.03.84-1.88,1.88-1.88h5.62v21.56c0,3.62-2.94,6.56-6.56,6.56-3.39,0-6.19-2.57-6.53-5.87-.61.16-1.25.25-1.91.25-4.14,0-7.5-3.36-7.5-7.5,0-.87.15-1.71.42-2.48-3.54-1.34-6.05-4.76-6.05-8.77,0-3.74,2.19-6.97,5.37-8.47-1.02-1.28-1.62-2.89-1.62-4.65,0-3.6,2.53-6.6,5.91-7.34-.19-.64-.28-1.34-.28-2.04,0-3.5,2.41-6.46,5.66-7.28.35-3.28,3.14-5.85,6.53-5.85,3.62,0,6.56,2.94,6.56,6.56v8.44ZM18.75,15c1.04,0,1.88.84,1.88,1.88s-.84,1.88-1.88,1.88-1.88-.84-1.88-1.88.84-1.88,1.88-1.88ZM18.75,41.25c1.04,0,1.88.84,1.88,1.88s-.84,1.88-1.88,1.88-1.88-.84-1.88-1.88.84-1.88,1.88-1.88ZM37.5,18.75c1.03,0,1.88.84,1.88,1.88v.32c-2.18.77-3.75,2.86-3.75,5.31,0,3.11,2.52,5.62,5.62,5.62s5.62-2.52,5.62-5.62c0-2.45-1.57-4.54-3.75-5.31v-.32c0-3.11-2.52-5.62-5.62-5.62h-5.62V6.56c0-3.62,2.94-6.56,6.56-6.56,3.39,0,6.16,2.57,6.53,5.85,3.25.82,5.66,3.77,5.66,7.28,0,.7-.09,1.39-.28,2.04,3.38.74,5.91,3.74,5.91,7.34,0,1.76-.6,3.38-1.62,4.65,3.18,1.5,5.37,4.73,5.37,8.47,0,4.01-2.51,7.43-6.05,8.77.27.77.42,1.62.42,2.48,0,4.14-3.36,7.5-7.5,7.5-.66,0-1.3-.08-1.91-.25-.35,3.3-3.14,5.87-6.53,5.87-3.62,0-6.56-2.94-6.56-6.56v-8.44h4.07c.77,2.18,2.86,3.75,5.31,3.75,3.11,0,5.62-2.52,5.62-5.62s-2.52-5.62-5.62-5.62c-2.45,0-4.54,1.57-5.31,3.75h-4.07v-22.5h5.62ZM43.12,26.25c0,1.04-.84,1.88-1.88,1.88s-1.88-.84-1.88-1.88.84-1.88,1.88-1.88,1.88.84,1.88,1.88ZM41.25,41.25c1.04,0,1.88.84,1.88,1.88s-.84,1.88-1.88,1.88-1.88-.84-1.88-1.88.84-1.88,1.88-1.88Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
				}
				&.text-summarisation .icon i {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52.5 60'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M45,0h3.75c2.07,0,3.75,1.68,3.75,3.75v37.5c0,2.07-1.68,3.75-3.75,3.75v7.5c2.07,0,3.75,1.68,3.75,3.75s-1.68,3.75-3.75,3.75H11.25c-6.21,0-11.25-5.04-11.25-11.25V11.25C0,5.04,5.04,0,11.25,0h33.75ZM7.5,48.75c0,2.07,1.68,3.75,3.75,3.75h30v-7.5H11.25c-2.07,0-3.75,1.68-3.75,3.75ZM16.88,18.75h22.5c1.03,0,1.88-.84,1.88-1.88s-.84-1.88-1.88-1.88h-22.5c-1.03,0-1.88.84-1.88,1.88s.84,1.88,1.88,1.88ZM15,24.38c0,1.03.84,1.88,1.88,1.88h22.5c1.03,0,1.88-.84,1.88-1.88s-.84-1.88-1.88-1.88h-22.5c-1.03,0-1.88.84-1.88,1.88Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
				}
				&.keyword-extraction .icon i {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 75 45'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M0,7.5C0,3.36,3.36,0,7.5,0h60c4.14,0,7.5,3.36,7.5,7.5v30c0,4.14-3.36,7.5-7.5,7.5H7.5c-4.14,0-7.5-3.36-7.5-7.5V7.5ZM7.5,7.5v30h60V7.5H7.5ZM21.56,11.25c1.11,0,2.12.66,2.57,1.68l7.5,16.88c.63,1.42-.01,3.08-1.43,3.71s-3.08-.01-3.71-1.43l-.5-1.14h-8.84l-.5,1.14c-.63,1.42-2.3,2.06-3.71,1.43s-2.06-2.3-1.43-3.71l7.5-16.88c.46-1.02,1.45-1.68,2.57-1.68ZM21.56,20.99l-1.92,4.32h3.84l-1.92-4.32ZM35.62,14.06c0-1.56,1.25-2.81,2.81-2.81h6.09c3.88,0,7.03,3.15,7.03,7.03,0,1.08-.25,2.1-.68,3.01,1.56,1.29,2.55,3.23,2.55,5.43,0,3.88-3.15,7.03-7.03,7.03h-7.97c-1.56,0-2.81-1.25-2.81-2.81V14.06ZM41.25,16.88v2.81h3.28c.77,0,1.41-.63,1.41-1.41s-.63-1.41-1.41-1.41h-3.28ZM41.25,28.12h5.16c.77,0,1.41-.63,1.41-1.41s-.63-1.41-1.41-1.41h-5.16v2.81Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
				}
				&.text-enhancement .icon i {
					background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 67.49 45.02'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M18.76,41.26c-6.21,0-11.25-5.04-11.25-11.25v-15h-3.75c-1.52,0-2.88-.91-3.47-2.32s-.27-3.01.81-4.09L8.6,1.1c1.46-1.46,3.84-1.46,5.31,0l7.5,7.5c1.07,1.08,1.39,2.68.81,4.09s-1.96,2.32-3.47,2.32h-3.75v15c0,2.07,1.68,3.75,3.75,3.75h13.12c2.07,0,3.75,1.68,3.75,3.75s-1.68,3.75-3.75,3.75h-13.11ZM48.74,3.76c6.21,0,11.25,5.04,11.25,11.25v15h3.75c1.52,0,2.88.91,3.47,2.32s.27,3.01-.81,4.09l-7.5,7.5c-1.46,1.46-3.84,1.46-5.31,0l-7.5-7.5c-1.07-1.08-1.39-2.68-.81-4.09s1.96-2.32,3.47-2.32h3.75v-15c0-2.07-1.68-3.75-3.75-3.75h-13.12c-2.07,0-3.75-1.68-3.75-3.75s1.68-3.75,3.75-3.75h13.11Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
				}
			}
		}
	}
	.TextExtraction .icon i {
		background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 60'%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cpolygon class='b' points='37 0 37 15 52 15 37 0'/%3E%3Cpath class='b' d='M33.25,15V0H14.5c-4.14,0-7.5,3.36-7.5,7.5v26h14.5c3.03,0,5.5,2.47,5.5,5.5s-2.47,5.5-5.5,5.5H7v8c0,4.14,3.36,7.5,7.5,7.5h30c4.14,0,7.5-3.36,7.5-7.5V18.75h-15c-2.07,0-3.75-1.68-3.75-3.75ZM34.5,51.5H15.5c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h19c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5ZM48,29c0,1.38-1.12,2.5-2.5,2.5h-19c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h19c1.38,0,2.5,1.12,2.5,2.5Z'/%3E%3Cpath class='b' d='M21.5,41.5c1.38,0,2.5-1.12,2.5-2.5s-1.05-2.42-2.37-2.49c-.04,0-.08-.01-.13-.01H2.5c-.07,0-.13.01-.19.02-1.17.09-2.11.99-2.27,2.14-.02.11-.03.22-.03.34,0,.11.02.21.03.31.15,1.23,1.2,2.19,2.47,2.19h19Z'/%3E%3C/svg%3E");
	}
	.DataPrediction .icon i {
		background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 75 60'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M0,56.87c0-8.62,7-15.62,15.62-15.62h6.25c8.64,0,15.63,7,15.63,15.62,0,1.72-1.39,3.13-3.13,3.13H3.13c-1.73,0-3.13-1.39-3.13-3.13ZM7.5,26.25c0-4.02,2.14-7.73,5.62-9.74,3.48-2.01,7.77-2.01,11.25,0,3.48,2.01,5.62,5.72,5.62,9.74s-2.14,7.73-5.62,9.74c-3.48,2.01-7.77,2.01-11.25,0-3.48-2.01-5.62-5.72-5.62-9.74ZM18.75,7.5c0-4.14,3.36-7.5,7.5-7.5h41.25c4.14,0,7.5,3.36,7.5,7.5v33.75c0,4.14-3.36,7.5-7.5,7.5h-28.03c-1.38-2.99-3.5-5.57-6.14-7.5h34.17V7.5H26.25v5.75c-2.2-1.28-4.77-2-7.5-2v-3.75ZM48.36,16.32c-.54-.54-.69-1.35-.41-2.04s.97-1.16,1.73-1.16h10.31c1.03,0,1.88.84,1.88,1.88v10.31c0,.76-.46,1.44-1.16,1.73s-1.51.13-2.04-.41l-3.16-3.16-8.52,8.52c-1.1,1.1-2.88,1.1-3.97,0l-7.5-7.5c-1.1-1.1-1.1-2.88,0-3.97s2.88-1.1,3.97,0l5.51,5.51,6.53-6.53-3.16-3.16h0Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
	}
	.TimeSeriesAnalysis .icon i {
		background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 75 56.25'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M18.75,24.38h18.75v-6.41c-3.32-1.44-5.62-4.75-5.62-8.59,0-5.18,4.2-9.38,9.38-9.38s9.38,4.2,9.38,9.38c0,3.84-2.31,7.15-5.62,8.59v6.41h17.19l-4.85-4.84c-1.46-1.46-1.46-3.84,0-5.31s3.84-1.46,5.31,0l11.25,11.25c1.46,1.46,1.46,3.84,0,5.31l-11.25,11.25c-1.46,1.46-3.84,1.46-5.31,0s-1.46-3.84,0-5.31l4.85-4.85H30v6.41c3.32,1.44,5.62,4.75,5.62,8.59,0,5.18-4.2,9.38-9.38,9.38s-9.38-4.2-9.38-9.38c0-3.84,2.31-7.15,5.62-8.59v-6.41H3.75c-2.07,0-3.75-1.68-3.75-3.75s1.68-3.75,3.75-3.75h7.5v-6.41c-3.32-1.44-5.62-4.75-5.62-8.59C5.62,4.2,9.82,0,15,0s9.38,4.2,9.38,9.38c0,3.84-2.31,7.15-5.62,8.59v6.41ZM12.19,9.38c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81-1.26-2.81-2.81-2.81-2.81,1.26-2.81,2.81ZM23.44,46.88c0,1.55,1.26,2.81,2.81,2.81s2.81-1.26,2.81-2.81-1.26-2.81-2.81-2.81-2.81,1.26-2.81,2.81ZM41.25,12.19c1.55,0,2.81-1.26,2.81-2.81s-1.26-2.81-2.81-2.81-2.81,1.26-2.81,2.81,1.26,2.81,2.81,2.81Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
	}
	.SentimentAnalysis .icon i {
		background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 60'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M28.12,15h-4.07c-.77-2.18-2.86-3.75-5.31-3.75-3.11,0-5.62,2.52-5.62,5.62s2.52,5.62,5.62,5.62c2.45,0,4.54-1.57,5.31-3.75h4.07v9.38h-5.62c-3.11,0-5.62,2.52-5.62,5.62v4.07c-2.18.77-3.75,2.86-3.75,5.31,0,3.11,2.52,5.62,5.62,5.62s5.62-2.52,5.62-5.62c0-2.45-1.57-4.54-3.75-5.31v-4.07c0-1.03.84-1.88,1.88-1.88h5.62v21.56c0,3.62-2.94,6.56-6.56,6.56-3.39,0-6.19-2.57-6.53-5.87-.61.16-1.25.25-1.91.25-4.14,0-7.5-3.36-7.5-7.5,0-.87.15-1.71.42-2.48-3.54-1.34-6.05-4.76-6.05-8.77,0-3.74,2.19-6.97,5.37-8.47-1.02-1.28-1.62-2.89-1.62-4.65,0-3.6,2.53-6.6,5.91-7.34-.19-.64-.28-1.34-.28-2.04,0-3.5,2.41-6.46,5.66-7.28.35-3.28,3.14-5.85,6.53-5.85,3.62,0,6.56,2.94,6.56,6.56v8.44ZM18.75,15c1.04,0,1.88.84,1.88,1.88s-.84,1.88-1.88,1.88-1.88-.84-1.88-1.88.84-1.88,1.88-1.88ZM18.75,41.25c1.04,0,1.88.84,1.88,1.88s-.84,1.88-1.88,1.88-1.88-.84-1.88-1.88.84-1.88,1.88-1.88ZM37.5,18.75c1.03,0,1.88.84,1.88,1.88v.32c-2.18.77-3.75,2.86-3.75,5.31,0,3.11,2.52,5.62,5.62,5.62s5.62-2.52,5.62-5.62c0-2.45-1.57-4.54-3.75-5.31v-.32c0-3.11-2.52-5.62-5.62-5.62h-5.62V6.56c0-3.62,2.94-6.56,6.56-6.56,3.39,0,6.16,2.57,6.53,5.85,3.25.82,5.66,3.77,5.66,7.28,0,.7-.09,1.39-.28,2.04,3.38.74,5.91,3.74,5.91,7.34,0,1.76-.6,3.38-1.62,4.65,3.18,1.5,5.37,4.73,5.37,8.47,0,4.01-2.51,7.43-6.05,8.77.27.77.42,1.62.42,2.48,0,4.14-3.36,7.5-7.5,7.5-.66,0-1.3-.08-1.91-.25-.35,3.3-3.14,5.87-6.53,5.87-3.62,0-6.56-2.94-6.56-6.56v-8.44h4.07c.77,2.18,2.86,3.75,5.31,3.75,3.11,0,5.62-2.52,5.62-5.62s-2.52-5.62-5.62-5.62c-2.45,0-4.54,1.57-5.31,3.75h-4.07v-22.5h5.62ZM43.12,26.25c0,1.04-.84,1.88-1.88,1.88s-1.88-.84-1.88-1.88.84-1.88,1.88-1.88,1.88.84,1.88,1.88ZM41.25,41.25c1.04,0,1.88.84,1.88,1.88s-.84,1.88-1.88,1.88-1.88-.84-1.88-1.88.84-1.88,1.88-1.88Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
	}
	.TextSummarisation .icon i {
		background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52.5 60'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M45,0h3.75c2.07,0,3.75,1.68,3.75,3.75v37.5c0,2.07-1.68,3.75-3.75,3.75v7.5c2.07,0,3.75,1.68,3.75,3.75s-1.68,3.75-3.75,3.75H11.25c-6.21,0-11.25-5.04-11.25-11.25V11.25C0,5.04,5.04,0,11.25,0h33.75ZM7.5,48.75c0,2.07,1.68,3.75,3.75,3.75h30v-7.5H11.25c-2.07,0-3.75,1.68-3.75,3.75ZM16.88,18.75h22.5c1.03,0,1.88-.84,1.88-1.88s-.84-1.88-1.88-1.88h-22.5c-1.03,0-1.88.84-1.88,1.88s.84,1.88,1.88,1.88ZM15,24.38c0,1.03.84,1.88,1.88,1.88h22.5c1.03,0,1.88-.84,1.88-1.88s-.84-1.88-1.88-1.88h-22.5c-1.03,0-1.88.84-1.88,1.88Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
	}
	.KeywordExtraction .icon i {
		background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 75 45'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M0,7.5C0,3.36,3.36,0,7.5,0h60c4.14,0,7.5,3.36,7.5,7.5v30c0,4.14-3.36,7.5-7.5,7.5H7.5c-4.14,0-7.5-3.36-7.5-7.5V7.5ZM7.5,7.5v30h60V7.5H7.5ZM21.56,11.25c1.11,0,2.12.66,2.57,1.68l7.5,16.88c.63,1.42-.01,3.08-1.43,3.71s-3.08-.01-3.71-1.43l-.5-1.14h-8.84l-.5,1.14c-.63,1.42-2.3,2.06-3.71,1.43s-2.06-2.3-1.43-3.71l7.5-16.88c.46-1.02,1.45-1.68,2.57-1.68ZM21.56,20.99l-1.92,4.32h3.84l-1.92-4.32ZM35.62,14.06c0-1.56,1.25-2.81,2.81-2.81h6.09c3.88,0,7.03,3.15,7.03,7.03,0,1.08-.25,2.1-.68,3.01,1.56,1.29,2.55,3.23,2.55,5.43,0,3.88-3.15,7.03-7.03,7.03h-7.97c-1.56,0-2.81-1.25-2.81-2.81V14.06ZM41.25,16.88v2.81h3.28c.77,0,1.41-.63,1.41-1.41s-.63-1.41-1.41-1.41h-3.28ZM41.25,28.12h5.16c.77,0,1.41-.63,1.41-1.41s-.63-1.41-1.41-1.41h-5.16v2.81Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
	}
	.EnhanceText .icon i {
		background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 67.49 45.02'%3E%3Cdefs%3E%3Cstyle%3E.c%7Bisolation:isolate;%7D.d%7Bfill:%23deb303;stroke-width:0px;%7D%3C/style%3E%3C/defs%3E%3Cg id='b' class='c'%3E%3Cg class='c'%3E%3Cpath class='d' d='M18.76,41.26c-6.21,0-11.25-5.04-11.25-11.25v-15h-3.75c-1.52,0-2.88-.91-3.47-2.32s-.27-3.01.81-4.09L8.6,1.1c1.46-1.46,3.84-1.46,5.31,0l7.5,7.5c1.07,1.08,1.39,2.68.81,4.09s-1.96,2.32-3.47,2.32h-3.75v15c0,2.07,1.68,3.75,3.75,3.75h13.12c2.07,0,3.75,1.68,3.75,3.75s-1.68,3.75-3.75,3.75h-13.11ZM48.74,3.76c6.21,0,11.25,5.04,11.25,11.25v15h3.75c1.52,0,2.88.91,3.47,2.32s.27,3.01-.81,4.09l-7.5,7.5c-1.46,1.46-3.84,1.46-5.31,0l-7.5-7.5c-1.07-1.08-1.39-2.68-.81-4.09s1.96-2.32,3.47-2.32h3.75v-15c0-2.07-1.68-3.75-3.75-3.75h-13.12c-2.07,0-3.75-1.68-3.75-3.75s1.68-3.75,3.75-3.75h13.11Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
	}
	.ai-icon {
		color: $tertiary-text-colour;
	}

	:deep(.modal-inner-container) {
		width: 60% !important;
	}
	:deep(.modal-header) {
		display: grid !important;
		grid-template-columns: 100px 1fr 60px !important;
		.modal-title {
			line-height: 70px;
		}
		.icon {
			display: flex;
			height: 70px;
			width: 70px;
			background-color: rgb(1 32 60);
			border-radius: 16px;
			justify-content: center;
			align-items: center;
			i {
				background-size: contain;
				display: block;
				width: 30px;
				height: 30px;
				background-repeat: no-repeat;
				background-position: center center;
			}
		}
	}
	:deep(.modal-content) {
		display: grid;
		margin-left: 100px;
		grid-template-columns: 1fr 0.8fr;
		gap: 2rem;
		margin-right: 60px;
		padding-top: 0!important;
		.title {
			font-weight: bold;
			font-size: 16px;
			margin-bottom: 0.5rem;
		}
		.text {
			font-size: 14px;
			line-height: 1.4;
			margin-bottom: 1rem;
			&.overview {
				font-size: 16px !important;
			}
		}
		.link {
			display: block;
			&:hover {
				color: darken(#4863F0, 10%);
				text-decoration: underline;
				text-decoration-style: dotted;
			}
		}
	}
	:deep(.modal-footer) {
		margin-left: 100px !important;
	}
	button.btn.btn-save {
		svg {
			margin-right: 0.5rem;
		}
		background-image: linear-gradient(
			355deg,
			hsl(258deg 96% 67%) 0%,
			hsl(260deg 95% 67%) 21%,
			hsl(262deg 94% 66%) 32%,
			hsl(265deg 93% 66%) 39%,
			hsl(267deg 92% 66%) 44%,
			hsl(269deg 90% 65%) 49%,
			hsl(271deg 89% 65%) 53%,
			hsl(273deg 88% 64%) 58%,
			hsl(275deg 87% 64%) 64%,
			hsl(277deg 85% 63%) 71%,
			hsl(279deg 84% 63%) 79%,
			hsl(281deg 83% 62%) 88%,
			hsl(283deg 82% 62%) 100% );
		padding: 0.75rem 2rem;
		border-radius: 5px;
		border: 0;
		&:hover {
			transition: 0.3s ease-in-out all;
			background-image: linear-gradient(
				355deg,
				hsl(258deg 95% 64%) 0%,
				hsl(260deg 93% 64%) 13%,
				hsl(262deg 92% 64%) 25%,
				hsl(265deg 91% 63%) 37%,
				hsl(267deg 90% 63%) 49%,
				hsl(269deg 89% 63%) 61%,
				hsl(271deg 88% 63%) 71%,
				hsl(273deg 87% 63%) 81%,
				hsl(275deg 86% 62%) 89%,
				hsl(277deg 85% 62%) 94%,
				hsl(279deg 84% 62%) 97%,
				hsl(281deg 83% 62%) 99%,
				hsl(283deg 82% 62%) 100% );
			text-shadow: 0 0 3px #ffffff;
			color: white;
		}
	}
	.ai-says {
		background-image: linear-gradient(
			355deg,
			hsl(258deg 95% 64%) 0%,
			hsl(260deg 93% 64%) 13%,
			hsl(262deg 92% 64%) 25%,
			hsl(265deg 91% 63%) 37%,
			hsl(267deg 90% 63%) 49%,
			hsl(269deg 89% 63%) 61%,
			hsl(271deg 88% 63%) 71%,
			hsl(273deg 87% 63%) 81%,
			hsl(275deg 86% 62%) 89%,
			hsl(277deg 85% 62%) 94%,
			hsl(279deg 84% 62%) 97%,
			hsl(281deg 83% 62%) 99%,
			hsl(283deg 82% 62%) 100% );
		color: transparent;
		background-clip: text;
	}
	.waiting {
		font-style: italic;
		color: $alert-secondary-colour;
	}
</style>
